module.exports = __webpack_public_path__ + "static/media/image00.bb7fa622.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image00.jpg
// module id = 314
// module chunks = 0